import OktaAuth from '@okta/okta-auth-js';
import { env } from '../_tools/env';

let oktaAuth = null;

export function initOktaAuth() {
    const domain = env('VUE_APP_OKTA_DOMAIN');
    const clientId = env('VUE_APP_OKTA_CLIENT_ID');
    const redirectUri = env('VUE_APP_OKTA_REDIRECT_URI');

    if (!domain || !clientId || !redirectUri) {
        return null;
    }

    oktaAuth = new OktaAuth({
        issuer: domain,
        redirectUri: redirectUri,
        clientId: clientId,
    });

    return oktaAuth;
}

export function getOktaAuth() {
    return oktaAuth;
}

export function getAuthModes() {
    const modes = env('VUE_APP_AUTH_MODE', 'password').split(',').map(m => m.trim());
    return {
        isPasswordEnabled: modes.includes('password'),
        isOktaEnabled: modes.includes('okta'),
    };
}
